import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocaleContext from '../../contexts/LocaleContext';

import MainTitle from '../common/MainTitle';
import AppButton from '../common/AppButton';
import LeadershipSkills from './LeadershipSkills';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';
import { getStudentLeadershipData } from '../../js/api/homepage';
import ImageLink from '../../js/utils/ImageLink';

export default function StudentsLeadershipPotential() {
  const { t } = useTranslation(['HomePage']);
  const { locale } = useContext(LocaleContext);
  const { queryParams } = useNavigationWithQuery();
  const [data, setData] = useState(null);

  // Handle fetching homepage data.
  useEffect(() => {
    getStudentLeadershipData()
      .then((res) => {
        setData(res.data?.attributes?.section_3_image.data);
      })
      .catch((e) => {
        toast.error('An error occurred, try again later');
        throw e;
      });
  }, []);

  return (
    <section className="students-leadership">
      <div className="students-leadership__container container">
        <div className="students-leadership__content">
          <header className="students-leadership__header">
            <MainTitle type="dark" className="text--2xl">
              <span>{t('helpingStudents')}</span>
              <span className="decorated-line decorated-line--dark decorated-line--left">
                {t('reachTheirFull')}
              </span>
              <span>{t('leadershipPotential')}</span>
            </MainTitle>
          </header>

          <p className="hidden--mobile">{t('helpingStudentsContent')}</p>
        </div>

        <div className="students-leadership__media">
          <picture>
            <source srcSet={ImageLink(data?.attributes?.url)} type="image/webp" />
            <img src={ImageLink(data?.attributes?.url)} alt="conversation-between-two-students" />
          </picture>
        </div>
        <p className="hidden--desktop">{t('helpingStudentsContent')}</p>
      </div>

      <LeadershipSkills />

      <AppButton tag="a" linkPath={`/${locale}/about${queryParams}`}>
        {t('ourVision')}
      </AppButton>
    </section>
  );
}
